// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
export class ComboBoxProps {
}
export class ComboBoxComponentView {
}
export class ComboBoxViewModel extends AbstractViewModel {
    get menuItems() {
        return this.componentView.menuItems;
    }
    set menuItems(value) {
        this.updateComponentView('menuItems', value);
        this.selectedItem = value.find((item) => item.selected === true);
    }
    get selectedItem() {
        return this.componentView.selectedItem;
    }
    set selectedItem(value) {
        this.updateComponentView('selectedItem', value);
    }
    constructor() {
        super(ComboBoxComponentView);
    }
    initialize(props) {
        super.initialize(props);
        this.menuItems = props.items;
    }
    update(props) {
        super.update(props);
        this.menuItems = props.items;
    }
}
